import { Activity } from 'react';
import { Tabs } from '@tempmee/react';
import { useGetCandidateResume } from '~/domain/PermanentJobs';
import { IJob, IUser } from '~/models';
import { TNullable } from '~/types/Nullable';
import { ExperienceSkillsPreview, ResumePreview } from '../../components';

interface IExperienceOverview {
  job?: TNullable<IJob>;
  postingId?: string;
  professional: TNullable<IUser>;
  hasWorkedWithDSO?: boolean;
  hasWorkedWithOffice?: boolean;
}

export const ExperienceOverview = ({
  job,
  postingId,
  professional,
  hasWorkedWithDSO = false,
  hasWorkedWithOffice = false,
}: IExperienceOverview) => {
  const resolvedPostingId = postingId ?? job?.postingId;

  const { data: resume } = useGetCandidateResume(
    { professionalId: professional?.id || '', postingId: resolvedPostingId },
    { enabled: !!resolvedPostingId && !!professional?.id },
  );

  const hasGoTuResume = !!resume;

  return (
    <>
      <Activity mode={hasGoTuResume ? 'visible' : 'hidden'}>
        <Tabs defaultValue="gotu-resume" style={{ alignItems: 'flex-start', gap: 16 }}>
          <Tabs.List style={{ gap: 16 }}>
            <Tabs.Tab value="gotu-resume">GoTu Resume</Tabs.Tab>
            <Tabs.Tab value="experience-skills">Experience & Skills</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="gotu-resume" style={{ width: '100%' }}>
            <ResumePreview
              educations={(resume?.education || [])?.map((it) => ({
                graduatesAt: it.graduationDate,
                institutionName: it.institutionName,
              }))}
              experiences={(resume?.experiences || [])?.map((it) => ({
                employerName: it.employerName,
                endsAt: it.endDate,
                isCurrentEmployer: it.isCurrentEmployer,
                startsAt: it.startDate,
                title: it.title,
              }))}
              professionalName={resume?.professionalFirstName || ''}
              summaries={resume?.summary || ''}
            />
          </Tabs.Panel>
          <Tabs.Panel value="experience-skills" style={{ width: '100%' }}>
            <ExperienceSkillsPreview
              job={job}
              professional={professional}
              hasWorkedWithDSO={hasWorkedWithDSO}
              hasWorkedWithOffice={hasWorkedWithOffice}
            />
          </Tabs.Panel>
        </Tabs>
      </Activity>
      <Activity mode={hasGoTuResume ? 'hidden' : 'visible'}>
        <ExperienceSkillsPreview
          job={job}
          professional={professional}
          hasWorkedWithDSO={hasWorkedWithDSO}
          hasWorkedWithOffice={hasWorkedWithOffice}
        />
      </Activity>
    </>
  );
};
